import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ImpersonationService } from '../../../infrastructure/services/impersonation.service';

@Component({
    selector: 'app-impersonation-banner',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './impersonation-banner.component.html',
    styleUrl: './impersonation-banner.component.scss',
})
export class ImpersonationBannerComponent {
    readonly impersonationService = inject(ImpersonationService);
    readonly router = inject(Router);

    readonly isActive = this.impersonationService.isActive;
    readonly remainingTime = this.impersonationService.remainingTime;
    readonly isWriteMode = this.impersonationService.canWrite;

    readonly email = computed(() => {
        const session = this.impersonationService.session();
        return session?.claims?.email || session?.claims?.sub || '';
    });

    endSession(): void {
        this.impersonationService.clearSession();
        this.router.navigate(['/login']);
    }
}
